import { Resource } from './resource';
import { InterviewStepMapping } from './interviewStepMapping';
import { User } from './user';

export class InterviewStep extends Resource {

 id :string;
 interviewId :string;
 startDate :string;
 date :string;
 interviewer :User;
 interviewStep :any;
interviewStepStatus :any;
interviewerObj:any;
comment :string;
interview: any;
notes : string;
user :User;
startTime:string;
pass:boolean;
interviewMode:string;
scheduledById:string;
primaryRecruiter:string;
mailSentOrNot:any;
showPreviousFeedback:boolean;
  }